import service from './http'
// 查询试卷习题明细列表
export function examinationItemList (data) {
  return service({
    url: '/examinationItem/findList',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}


// 查询试卷习题明细列表
export function examinationItemWrong (data) {
  return service({
    url: '/examinationItemWrong/findList',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}



// 题库详情
export function examinationInfo (data) {
  return service({
    url: '/examination/findInfo',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token') || ''
    }
  })
}

// 题库提交数据
export function submitExaminationTestLog (data) {
  return service({
    url: '/customerExaminationTestLog/editPost',
    method: 'post',
    data: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}

// 查看测试结果
export function getCustomerExaminationResult (data) {
  return service({
    url: '/customerExaminationTestLog/findInfo',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}

import { postRequest }  from './axios'

//异步 错题报错  不让出现刷新效果
export const wrongFeedback = (data) => {
  return postRequest('/examinationWrongFeedback/editPost', data)
}


// 错题报错
// export function wrongFeedback (data) {
//   return service({
//     url: '/examinationWrongFeedback/editPost',
//     method: 'post',
//     data: data,
//     headers: {
//       Authorization: localStorage.getItem('shangke_token')
//     }
//   })
// }



// 收藏试题
export function editExaminationItemCollect (data) {
  return service({
    url: '/examinationItemCollect/editPost',
    method: 'post',
    data: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}


// 题库收藏列表对应的试卷
export function getExaminationItemCollectExamination(data) {
  return service({
    url: '/examinationItemCollect/findExaminationItemCollectExamination',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}
// 题库收藏列表对应的课程
export function getExaminationItemCollectCourse(data) {
  return service({
    url: '/examinationItemCollect/findExaminationItemCollectCourse',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}
// 题库类型列表
export function examinationTypeList (data) {
  return service({
    url: '/examinationType/findList',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token') || ''
    }
  })
}// 错题列表对应的试卷
export function getExaminationItemWrongExamination(data) {
  return service({
    url: '/examinationItemWrong/findExaminationItemWrongExamination',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}

// 个人中心题库分类
export function deleteExaminationItemWrong (data) {
  return service({
    url: '/examinationItemWrong/delete',
    method: 'post',
    data: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}

// 查询收藏试题对应的试卷列表
export function getExaminationItemCollect(data) {
  return service({
    url: '/examinationItemCollect/findList',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}